/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { taxCategoriesGet } from '../fn/tax-categories/tax-categories-get';
import { TaxCategoriesGet$Params } from '../fn/tax-categories/tax-categories-get';
import { taxCategoriesPost } from '../fn/tax-categories/tax-categories-post';
import { TaxCategoriesPost$Params } from '../fn/tax-categories/tax-categories-post';
import { taxCategoriesTaxCategoryIdDelete } from '../fn/tax-categories/tax-categories-tax-category-id-delete';
import { TaxCategoriesTaxCategoryIdDelete$Params } from '../fn/tax-categories/tax-categories-tax-category-id-delete';
import { taxCategoriesTaxCategoryIdGet } from '../fn/tax-categories/tax-categories-tax-category-id-get';
import { TaxCategoriesTaxCategoryIdGet$Params } from '../fn/tax-categories/tax-categories-tax-category-id-get';
import { taxCategoriesTaxCategoryIdPut } from '../fn/tax-categories/tax-categories-tax-category-id-put';
import { TaxCategoriesTaxCategoryIdPut$Params } from '../fn/tax-categories/tax-categories-tax-category-id-put';
import { TaxCategory } from '../models/tax-category';
import { TaxCategoryListResponse } from '../models/tax-category-list-response';

@Injectable({ providedIn: 'root' })
export class TaxCategoriesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `taxCategoriesGet()` */
  static readonly TaxCategoriesGetPath = '/tax-categories';

  /**
   * List Tax Categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxCategoriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxCategoriesGet$Response(params: TaxCategoriesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategoryListResponse>> {
    return taxCategoriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * List Tax Categories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxCategoriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxCategoriesGet(params: TaxCategoriesGet$Params, context?: HttpContext): Observable<TaxCategoryListResponse> {
    return this.taxCategoriesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TaxCategoryListResponse>): TaxCategoryListResponse => r.body)
    );
  }

  /** Path part for operation `taxCategoriesPost()` */
  static readonly TaxCategoriesPostPath = '/tax-categories';

  /**
   * Create a Tax Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxCategoriesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxCategoriesPost$Response(params: TaxCategoriesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategory>> {
    return taxCategoriesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a Tax Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxCategoriesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxCategoriesPost(params: TaxCategoriesPost$Params, context?: HttpContext): Observable<TaxCategory> {
    return this.taxCategoriesPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TaxCategory>): TaxCategory => r.body)
    );
  }

  /** Path part for operation `taxCategoriesTaxCategoryIdGet()` */
  static readonly TaxCategoriesTaxCategoryIdGetPath = '/tax-categories/{taxCategoryId}';

  /**
   * Get a Tax Category by its ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxCategoriesTaxCategoryIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxCategoriesTaxCategoryIdGet$Response(params: TaxCategoriesTaxCategoryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategory>> {
    return taxCategoriesTaxCategoryIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a Tax Category by its ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxCategoriesTaxCategoryIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxCategoriesTaxCategoryIdGet(params: TaxCategoriesTaxCategoryIdGet$Params, context?: HttpContext): Observable<TaxCategory> {
    return this.taxCategoriesTaxCategoryIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TaxCategory>): TaxCategory => r.body)
    );
  }

  /** Path part for operation `taxCategoriesTaxCategoryIdPut()` */
  static readonly TaxCategoriesTaxCategoryIdPutPath = '/tax-categories/{taxCategoryId}';

  /**
   * Update a Tax Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxCategoriesTaxCategoryIdPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxCategoriesTaxCategoryIdPut$Response(params: TaxCategoriesTaxCategoryIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategory>> {
    return taxCategoriesTaxCategoryIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a Tax Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxCategoriesTaxCategoryIdPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taxCategoriesTaxCategoryIdPut(params: TaxCategoriesTaxCategoryIdPut$Params, context?: HttpContext): Observable<TaxCategory> {
    return this.taxCategoriesTaxCategoryIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<TaxCategory>): TaxCategory => r.body)
    );
  }

  /** Path part for operation `taxCategoriesTaxCategoryIdDelete()` */
  static readonly TaxCategoriesTaxCategoryIdDeletePath = '/tax-categories/{taxCategoryId}';

  /**
   * Delete a Tax Category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taxCategoriesTaxCategoryIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxCategoriesTaxCategoryIdDelete$Response(params: TaxCategoriesTaxCategoryIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return taxCategoriesTaxCategoryIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a Tax Category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taxCategoriesTaxCategoryIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taxCategoriesTaxCategoryIdDelete(params: TaxCategoriesTaxCategoryIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.taxCategoriesTaxCategoryIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
